/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardDoughnutUseCase
 */
export interface DashboardDoughnutUseCase {
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCase
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCase
   */
  performanceValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCase
   */
  robustnessValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCase
   */
  explainabilityValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCase
   */
  fairnessValue: number;
  /**
   *
   * @type {string}
   * @memberof DashboardDoughnutUseCase
   */
  useCase: string;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCase
   */
  totalValue: number;
}

/**
 * Check if a given object implements the DashboardDoughnutUseCase interface.
 */
export function instanceOfDashboardDoughnutUseCase(value: object): value is DashboardDoughnutUseCase {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('performanceValue' in value) || value['performanceValue'] === undefined) return false;
  if (!('robustnessValue' in value) || value['robustnessValue'] === undefined) return false;
  if (!('explainabilityValue' in value) || value['explainabilityValue'] === undefined) return false;
  if (!('fairnessValue' in value) || value['fairnessValue'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('totalValue' in value) || value['totalValue'] === undefined) return false;
  return true;
}

export function DashboardDoughnutUseCaseFromJSON(json: any): DashboardDoughnutUseCase {
  return DashboardDoughnutUseCaseFromJSONTyped(json, false);
}

export function DashboardDoughnutUseCaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardDoughnutUseCase {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    performanceValue: json['performance_value'],
    robustnessValue: json['robustness_value'],
    explainabilityValue: json['explainability_value'],
    fairnessValue: json['fairness_value'],
    useCase: json['use_case'],
    totalValue: json['total_value'],
  };
}

export function DashboardDoughnutUseCaseToJSON(value?: DashboardDoughnutUseCase | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    performance_value: value['performanceValue'],
    robustness_value: value['robustnessValue'],
    explainability_value: value['explainabilityValue'],
    fairness_value: value['fairnessValue'],
    use_case: value['useCase'],
    total_value: value['totalValue'],
  };
}
